import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import MainLayout from "../../../layouts/MainLayout";
import "../../../assets/styles/custom-styles.css";
import DetailsSectionRenderer from "../../../components/DetailsSectionRenderer";
import useBaseService from "../../../hooks/services/useBaseService";
import useLoader from "../../../hooks/useLoader";
import useNotification from "../../../hooks/useNotification";
import { detailsLocationFields } from "../../../constants/forms/locationFields";
import useForm from "../../../hooks/useForm";
import { setDefaultFieldValues } from "../../../utils/objectUtils";
import { entities } from "../../../constants/entities";
import PageHeader from "../../../components/PageHeader";
import useQueryWithLoader from "../../../hooks/useQueryWithLoader";

const DetailsOrganizationLocationPage = () => {
  const navigate = useNavigate();
  const { organizationId, addressId, locationId } = useParams();

  const { getByColumn: baseServiceGetByColumn } = useBaseService(navigate);
  const { showLoader, hideLoader } = useLoader();
  const { showNotification } = useNotification();
  const { formData, setFormData } = useForm(
    setDefaultFieldValues(detailsLocationFields),
  );

  const {
    data: locationData,
    isLoading: isLoadingLocation,
    isError: isErrorLocation,
    error: locationQueryError,
  } = useQueryWithLoader({
    queryKey: [
      "organizationAddressLocation",
      organizationId,
      addressId,
      locationId,
    ],
    queryFn: async () => {
      showLoader();
      const response = await baseServiceGetByColumn(
        entities.organizations.organizationAddressLocation(
          organizationId,
          addressId,
          locationId,
        ),
      );
      return response.result;
    },
    enabled: !!organizationId && !!addressId && !!locationId,
  });

  useEffect(() => {
    if (!isLoadingLocation && locationData) {
      hideLoader();
      setFormData({
        area: locationData.area,
        section: locationData.section,
        spot: locationData.spot,
        details: locationData.details,
      });
    }
    if (isErrorLocation && locationQueryError) {
      hideLoader();
      console.error("Erro ao buscar localização:", locationQueryError);
      showNotification(
        "error",
        `Erro ao buscar localização: ${locationQueryError?.message}`,
      );
      navigate(
        `/aluguel/organizacoes/detalhes/${organizationId}/enderecos/${addressId}/localizacoes`,
      );
    }
  }, [
    locationData,
    isLoadingLocation,
    isErrorLocation,
    locationQueryError,
    hideLoader,
    setFormData,
    showNotification,
    navigate,
    organizationId,
    addressId,
  ]);

  return (
    <MainLayout selectedCompany="ALUCOM">
      <PageHeader
        title="Detalhes da Localização"
        showBackButton={true}
        backUrl={`/aluguel/organizacoes/detalhes/${organizationId}/enderecos/${addressId}/localizacoes`}
      />
      <div className="container-fluid p-1">
        <DetailsSectionRenderer
          sections={detailsLocationFields}
          formData={formData}
        />
      </div>
    </MainLayout>
  );
};

export default DetailsOrganizationLocationPage;
